import { render, staticRenderFns } from "./MailDocCanvas.vue?vue&type=template&id=256bb958&scoped=true&"
import script from "./MailDocCanvas.vue?vue&type=script&lang=js&"
export * from "./MailDocCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MailDocCanvas.vue?vue&type=style&index=0&id=256bb958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bb958",
  null
  
)

export default component.exports